<template>
  <div
    class="screen-acceptable-use-policy"
    :class="{ 'has-tab-bar': showTabBar }"
  >
    <app-bar title="Gebruiksbeleid" :show-back-button="true" />
    <div class="container">
      <h1>Gebruiksbeleid (Acceptable Use Policy)</h1>

      <p>
        Dit gebruiksbeleid beschrijft wat wel en niet is toegestaan op het
        Inviplay-platform. Het geldt voor alle gebruikers — deelnemers,
        organisatoren van activiteiten en beheerders van sportlocaties — en is
        een aanvulling op onze algemene voorwaarden. Door Inviplay te gebruiken
        ga je akkoord met dit beleid.
      </p>

      <h2>1. Toegestaan gebruik</h2>
      <p>
        Het platform mag alleen worden gebruikt waarvoor het bedoeld is: het
        plaatsen, vinden, deelnemen aan en betalen van legitieme sport- en
        beweegactiviteiten, en het boeken van sportlocaties. Betalingen via het
        platform mogen uitsluitend betrekking hebben op deelnamekosten voor
        activiteiten en boekingen die op het platform worden aangeboden.
      </p>

      <h2>2. Verboden activiteiten</h2>
      <p>
        Het is niet toegestaan om Inviplay te gebruiken voor, of om via Inviplay
        bij te dragen aan:
      </p>
      <ul class="list-inside list-disc my-2">
        <li>
          Activiteiten die in strijd zijn met wet- of regelgeving, in Nederland
          of daarbuiten;
        </li>
        <li>
          Fraude, misleiding of oplichting, waaronder het plaatsen van fictieve
          activiteiten, het aannemen van een valse identiteit of het opgeven van
          onjuiste profiel- of betaalgegevens;
        </li>
        <li>
          Witwassen, terrorismefinanciering of het overmaken van geld dat geen
          verband houdt met een echte activiteit of locatieboeking op het
          platform;
        </li>
        <li>
          De verkoop of promotie van goederen of diensten die niets met
          sportactiviteiten te maken hebben, waaronder in ieder geval drugs,
          wapens, namaakartikelen, gokken of content voor volwassenen;
        </li>
        <li>
          Inbreuk op intellectuele-eigendomsrechten of andere rechten van
          derden;
        </li>
        <li>
          Discriminatie, pesten, intimidatie, bedreiging, haatzaaien of
          agressief gedrag richting andere gebruikers, in berichten op het
          platform of tijdens activiteiten;
        </li>
        <li>
          Het plaatsen van content die onrechtmatig, aanstootgevend of
          lasterlijk is;
        </li>
        <li>
          Het versturen van spam of ongevraagde commerciële berichten aan andere
          gebruikers;
        </li>
        <li>
          Het omzeilen van de betaalflow van het platform voor activiteiten die
          op het platform worden aangeboden, of het gebruiken van de
          betaalfunctionaliteit voor een ander doel dan beschreven onder punt 1;
        </li>
        <li>
          Het verstoren van de veiligheid of werking van het platform, waaronder
          ongeautoriseerde toegangspogingen, scraping, het verspreiden van
          malware of het zoeken naar kwetsbaarheden;
        </li>
        <li>
          Het geautomatiseerd aanmaken van accounts, of het aanmaken van een
          nieuw account om een eerdere schorsing of verwijdering te omzeilen.
        </li>
      </ul>

      <h2>3. Organisatoren en commerciële partijen</h2>
      <p>
        Organisatoren zijn verantwoordelijk voor de juistheid van hun
        activiteiten (omschrijving, prijs, locatie, annuleringsvoorwaarden) en
        voor een veilige sportomgeving. Voor commerciële partijen kunnen
        aanvullende eisen gelden voordat zij activiteiten mogen plaatsen;
        Inviplay stelt hen daarvan op de hoogte. Organisatoren gaan
        vertrouwelijk om met deelnemersgegevens die zij via het platform
        ontvangen en gebruiken deze alleen voor het uitvoeren van de activiteit.
      </p>

      <h2>4. Betalingen</h2>
      <p>
        Betalingen op Inviplay worden verwerkt door Online Payment Platform
        (OPP), een betaaldienstverlener met een vergunning van De Nederlandsche
        Bank. Op betalingen zijn de voorwaarden van OPP van toepassing. Waar
        PayPal als betaalmethode wordt aangeboden, geldt daarnaast het
        Acceptable Use Policy van PayPal; het is niet toegestaan PayPal op
        Inviplay te gebruiken voor activiteiten die dat beleid verbiedt.
      </p>

      <h2>5. Handhaving</h2>
      <p>
        Inviplay ziet toe op naleving van dit beleid en kan bij overtreding,
        naar eigen inzicht en zonder voorafgaande aankondiging:
      </p>
      <ul class="list-inside list-disc my-2">
        <li>content of activiteiten verwijderen of aanpassen;</li>
        <li>accounts opschorten of definitief verwijderen;</li>
        <li>
          betalingen of uitbetalingen die verband houden met een overtreding
          inhouden, terugdraaien of weigeren;
        </li>
        <li>
          overtredingen melden bij de bevoegde autoriteiten en meewerken aan
          opsporing;
        </li>
        <li>
          de gebruiker aansprakelijk stellen voor schade die uit de overtreding
          voortvloeit.
        </li>
      </ul>
      <p class="mt-4">
        Verwijdering uit een activiteit door een organisator wegens het
        overtreden van de huisregels geeft geen recht op restitutie.
      </p>

      <h2>6. Overtredingen melden</h2>
      <p>
        Kom je op Inviplay content of gedrag tegen dat in strijd is met dit
        beleid? Meld het via
        <a href="mailto:contact@inviplay.nl">contact@inviplay.nl</a>
        . Wij beoordelen elke melding en ondernemen waar nodig actie.
      </p>

      <h2>7. Wijzigingen</h2>
      <p>
        Inviplay kan dit beleid van tijd tot tijd aanpassen. Substantiële
        wijzigingen worden aangekondigd via e-mail of een melding in de app.
        Door het platform te blijven gebruiken na een wijziging ga je akkoord
        met het aangepaste beleid.
      </p>

      <h2>8. Contact</h2>
      <p>
        Inviplay B.V.
        <br />
        Prinses Beatrixlaan 26
        <br />
        3554 JK Utrecht
        <br />
        <a href="mailto:contact@inviplay.nl">contact@inviplay.nl</a>
      </p>

      <p class="mt-4 text-sm"><em>Datum publicatie: 02/09/2026</em></p>
    </div>
    <tab-bar v-if="showTabBar" selected="profile" />
  </div>
</template>

<script>
import AppBar from '@/components/AppBar'
import TabBar from '@/components/TabBar'

export default {
  name: 'AcceptableUsePolicy',
  components: {
    AppBar,
    TabBar
  },
  data() {
    return {
      showTabBar: this.$route.query.hideTabBar !== 'true'
    }
  }
}
</script>

<style scoped></style>
